import React from "react";

export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div>
        <h1 className="font-serif text-3xl text-navy leading-tight" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-mutedsea mt-0.5">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
    </div>
  );
}
